// Quick Buy functionality with localized text
// NB: es-module-shims re-dispatche un DOMContentLoaded synthétique après le vrai —
// sans {once: true} + marqueur, les listeners se bindent en double (1 clic = 2 ajouts panier).
document.addEventListener('DOMContentLoaded', function() {
  const quickBuyButtons = document.querySelectorAll('.quick-buy-button');

  quickBuyButtons.forEach(button => {
    if (button.dataset.quickBuyBound) return;
    button.dataset.quickBuyBound = '1';
    button.addEventListener('click', async function(e) {
      e.preventDefault();

      if (this.disabled) return;

      const formId = this.getAttribute('data-product-form');
      const form = document.getElementById(formId);

      if (!form) return;
      
      // Get localized text from button data attributes
      const addingText = this.getAttribute('data-adding-text') || 'Adding...';
      const errorText = this.getAttribute('data-error-text') || 'Error';
      
      this.disabled = true;
      const originalHTML = this.innerHTML;
      
      // Update button with localized "Adding..." text
      this.innerHTML = '<span style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem;"><span>⏳</span><span>' + addingText + '</span></span>';
      
      try {
        const formData = new FormData(form);
        
        // Get existing cart note (preserve pickup point info)
        const cartData = await fetch('/cart.js').then(r => r.json());
        const existingNote = cartData.note || '';
        
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Update attributes only (preserve note for pickup points)
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: existingNote,
              attributes: {
                'Quick Buy Used': 'Yes',
                'Quick Buy Product': data.product_title,
                'Quick Buy Date': new Date().toLocaleString('fr-FR')
              }
            })
          });
          
          // Track with Google Analytics
          if (typeof gtag !== 'undefined') {
            gtag('event', 'quick_buy', {
              event_category: 'Quick Buy',
              event_label: data.product_title,
              value: data.price / 100
            });
          }
          
          // Redirect to checkout (flag pour rafraîchir le panier au retour bfcache)
          sessionStorage.setItem('lcf-quick-buy-checkout', '1');
          window.location.href = '/checkout';
        } else {
          const error = await response.json();
          alert(errorText + ': ' + (error.description || ''));
          this.disabled = false;
          this.innerHTML = originalHTML;
        }
      } catch (error) {
        console.error('Error:', error);
        alert(errorText);
        this.disabled = false;
        this.innerHTML = originalHTML;
      }
    });
  });
}, { once: true });

// Retour depuis le checkout via bfcache : le drawer iCart affiche l'état d'avant
// l'ajout (il paraît vide) — on recharge la page pour resynchroniser le panier.
window.addEventListener('pageshow', function(event) {
  if (event.persisted && sessionStorage.getItem('lcf-quick-buy-checkout')) {
    sessionStorage.removeItem('lcf-quick-buy-checkout');
    window.location.reload();
  } else if (!event.persisted) {
    sessionStorage.removeItem('lcf-quick-buy-checkout');
  }
});
